import { useAuthenticatedUser } from './Hooks/User'
import { Currency } from './Enums/Currency'

const CURRENCY_LOCALES: Record<Currency, string> = {
  [Currency.EUR]: 'de-DE',
  [Currency.DKK]: 'da-DK',
  [Currency.SEK]: 'sv-SE',
  [Currency.NOK]: 'nb-NO',
  [Currency.ISK]: 'is-IS',
  [Currency.GBP]: 'en-GB',
  [Currency.CHF]: 'de-CH',
  [Currency.PLN]: 'pl-PL',
  [Currency.CZK]: 'cs-CZ',
  [Currency.HUF]: 'hu-HU',
  [Currency.RON]: 'ro-RO',
  [Currency.BGN]: 'bg-BG',
  [Currency.RSD]: 'sr-RS',
  [Currency.ALL]: 'sq-AL',
  [Currency.BAM]: 'bs-BA',
  [Currency.MKD]: 'mk-MK',
  [Currency.MDL]: 'ro-MD',
  [Currency.UAH]: 'uk-UA',
  [Currency.BYN]: 'be-BY',
  [Currency.TRY]: 'tr-TR',
  [Currency.USD]: 'en-US',
  [Currency.CAD]: 'en-CA',
}

export function formatCurrency(
  amount: number,
  currency: Currency,
  showDecimals: boolean = true,
  showCurrency: boolean = true,
): string {
  if (isNaN(amount)) {
    return '0'
  }
  if (amount === 0) {
    return `${amount}`
  }

  const formatter = new Intl.NumberFormat(CURRENCY_LOCALES[currency], {
    style: showCurrency ? 'currency' : 'decimal',
    currency,
    minimumFractionDigits: showDecimals ? 2 : 0,
    maximumFractionDigits: showDecimals ? 2 : 0,
  })

  return formatter.format(amount)
}

export function useFormatCurrency() {
  const { data: authenticatedUser } = useAuthenticatedUser()
  const currency = authenticatedUser?.currency ?? Currency.DKK

  return (
    amount: number,
    showDecimals: boolean = true,
    showCurrency: boolean = true,
  ) => formatCurrency(amount, currency, showDecimals, showCurrency)
}
